import 'core-js/stable';
import 'regenerator-runtime/runtime';
// Support component names relative to this directory:
var componentRequireContext = require.context("components", true);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);

import '../../assets/stylesheets/main'

import '../../assets/javascripts/main'
